// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__18NON","load2":"Loader_load2__ymcWs"};